import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { helperFunctions } from "../helper";
import { URLConfig } from "../network/urlStore";
import { AgTechQueryParam, OdQueryParam } from "../enums";

// Generate Single Trial Report
export const generateSingleReport = (payload: {
  selectedTrialId: number;
  dryingDifference: number;
  pricePerBushel: number;
}): Observable<any> => {
  const url = URLConfig.getSingleReportURL();
  return new Observable((subscriber) => {
    NetworkService.post(url, payload).then(
      (res: unknown) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while generating single report", error);
      },
    );
  });
};

// Generate One to Many Report
export const generateOneToManyReport = (payload: {
  season: string;
  crop: string;
  country: string;
  region: number;
  SelectedProductId: number;
  TrialClassificationType?: string[];
  TrialType?: string[];
  productSetId?: number;
  brandId?: number;
  retailerId?: number;
  minimumComparisons?: number;
  dryingDifference?: number;
  pricePerBushel?: number;
}): Observable<any> => {
  const url = URLConfig.getOneToManyReportURL();
  return new Observable((subscriber) => {
    NetworkService.post(url, payload).then(
      (res: unknown) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while generating one to many report", error);
      },
    );
  });
};

// Generate Head to Head Report
export const generateHeadToHeadReport = (payload: {
  season: number;
  crop: string;
  country: string;
  RegionId: number[];
  SelectedProductId: number;
  ComparisonProductId: number;
  TrialClassificationType?: string[];
  TrialType?: string[];
  productSetId?: number[];
  retailerId?: number;
  minimumComparisons?: number;
  dryingDifference?: number;
  pricePerBushel?: number;
}): Observable<any> => {
  const url = URLConfig.getHeadToHeadReportURL();
  return new Observable((subscriber) => {
    NetworkService.post(url, payload).then(
      (res: unknown) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while generating Head to Head report", error);
      },
    );
  });
};

// Get OnFarm Trial Locations for One to Many Report
export const getOnFarmTrialLocations = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>,
): Observable<any> => {
  let url = URLConfig.getTrialExperimentsUrl();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching OnFarm trial locations", error);
      },
    );
  });
};
